export default "__VITE_ASSET__4ff8aa9e__"